import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { _formatPrice } from "../../../../../../shared/helpers/utils";
import { formatDate } from '../../../exportreport/utils';

const CustomBarChart = ({ theme, data, height = 300, isWeekly }) => {
  const maxValue = Math.max(...data.map((item) => item.value));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        margin={{ top: 50, right: 30, left: 0, bottom: 20 }}
      >
        <XAxis
          dataKey="date"
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 500,
          }}
          angle={-45}
          textAnchor="end"
          padding={{ left: 20, right: 20 }}
          height={100}
          tickFormatter={ (tick) => formatDate(tick, isWeekly )} 

        />

        <YAxis
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          domain={[0, maxValue]}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 500,
          }}
          tickFormatter={(value) => (value === 0 ? '' : value)} 

        />
        <Bar
          dataKey="NewDev"
          stackId="a"
          className="bar-element-chart"
          fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"}
        />
        <Bar
          dataKey="Condo"
          stackId="a"
          
          className="bar-element-chart1"
        />
        <Bar
          dataKey="Coop"
          stackId="a"
          
          className="bar-element-chart2"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
